import React, { useEffect, useRef, useState } from "react";
import { ApolloError, useReactiveVar } from "@apollo/client";
import { useGetCompanyQuery } from "@me-team/host/main/company/graphql/company.hooks";
import { ScheduleCalendarWrapperComponent } from "./ScheduleCalendarWrapperComponent";
import VioletBadge from "@services/ui-components/src/VioletBadge/VioletBadge";
import {
    AddAccessRightsButton,
    AddAccessRightsModal,
    AddEmployeeFromAnotherBranchModal,
    EmptyList,
    FiltersButton,
    ReactSelect,
    TableHeader,
} from "@services/ui-components";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetEmployeesPositionsQuery } from "@me-team/host/main/addEmployee/graphql/addEmployee.hooks";
import Spinner from "@services/ui-components/src/Spinner/Spinner";
import { useLocation, useParams } from "react-router-dom";
import AddVacationModal from "./modals/AddVacationModal/AddVacationModal";
import CustomDayModal from "./modals/CustomDayModal/CustomDayModal";
import JoyrideWrapper from "../Joyride/JoyrideWrapper";
import { useGetEmployeeForCheckEmptyListQuery } from "@me-team/host/main/work-shedule/graphql/workShedule.hooks";
import ToastComponent from "../ui-components/ToastComponent/ToastComponent";
import { useToast } from "../../hooks/useToast";
import { currentBranchEmployeeIdVar, currentCompanyIdVar } from "@me-team/host/main/globalVar/state";
import {
    useCreateUpdateUserBranchRelationMutation,
    useGetEmployeesNotInBranchQuery,
} from "@me-team/host/main/setUpAccessRole/graphql/setUpAccessRole.hooks";
import ErrorService from "../../services/ErrorService";
import { EmployeeProxy, UserBranchRelationInput } from "@me-team/host/main/graphql/types";
import { ErrorModalComponent } from "@me-pos/error-modal";
import i18next from "i18next";
import { FormDataAccessRights } from "@services/ui-components/src/Modal/EmployeeAccessToBranchModal/types";
import { useCheckScheduleForEmployeeQuery } from "@me-team/host/main/tutorial/graphql/tutorial.hooks";
import { DateTime } from "luxon";
import { useWorkScheduleAndLogbook } from "../../hooks/useWorkScheduleAndLogbook";
import { buildWorkScheduleCalendarAccess } from "./buildWorkScheduleCalendarAccess";
import { useWorkScheduleAccess } from "./useWorkScheduleAccess";

interface Option {
    value: any;
    label: string;
}
interface JoyrideStepEventDetail {
    direction: "back" | "next" | "other";
}

type JoyrideStepEvent = CustomEvent<JoyrideStepEventDetail>;

const WorkSchedule: React.FC = () => {
    const { t } = useTranslation();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const currentBranchEmployeeId = useReactiveVar(currentBranchEmployeeIdVar);
    const { id, branchId } = useParams();
    const location = useLocation();
    const [showFilters, setShowFilters] = useState(false);
    const [, setShowPreloader] = useState<boolean>(false);
    const [filter, setFilter] = useState({ positionId: null, employeeId: id ? +id : null });
    const [currentFilter, setCurrentFilter] = useState({ positionId: null, employeeId: null });
    const runJoy = localStorage.getItem("run") === "true";
    const step = localStorage.getItem("step") || "0";
    const [stepIndex, setStepIndex] = useState(+step);
    const [run, setRun] = useState(runJoy);
    const [, setModalJoyride] = useState(false);
    const [hasExistingSchedule, setHasExistingSchedule] = useState(false);
    const [eventTrigger, setEventTrigger] = useState(100);
    const [scheduleTrigger, setScheduleTrigger] = useState(100);
    const [keySchedule, setKeySchedule] = useState(0);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<number>(null);
    const [employeesWithoutAccessCurrentBranch, setEmployeesWithoutAccessCurrentBranch] = useState<EmployeeProxy[]>([]);
    const [showAddAccessRightsModal, setShowAddAccessRightsModal] = useState(false);
    const [isShowAddEmployeeFromAnotherBranchModal, setIsShowAddEmployeeFromAnotherBranchModal] = useState(false);
    const [selectedEmployeeToAdd, setSelectedEmployeeToAdd] = useState(null);

    const {
        refetchEmployeeList,
        handleRefetchEmployeeList,
        modalData,
        customModalData,
        editDate,
        handleCustomDay,
        handleWeekCellClick,
        handleCustomModalClose,
        handleCloseVacation,
        handleClickAddVacation,
    } = useWorkScheduleAndLogbook();

    const {
        canOpenEmployeeLinkAll,
        canOpenEmployeeLinkSelf,
        canCreateVacationAll,
        canCreateVacationSelf,
        canCreateCustomDayAll,
        canCreateCustomDaySelf,
        canEditCustomDayAll,
        canEditCustomDaySelf,
        canCreateScheduleAll,
        canCreateScheduleSelf,
        canEditScheduleAll,
        canEditScheduleSelf,
        canDeleteScheduleAll,
        canDeleteScheduleSelf,
        canManageBranchEmployees,
        workScheduleAccessContract,
        shouldShowOnlyOwnWorkSchedule,
        shouldHideEmployeeFilter,
        canShowAddEmployeeFromAnotherBranchAction,
    } = useWorkScheduleAccess();
    const isCurrentBranchEmployeePending = shouldShowOnlyOwnWorkSchedule && !currentBranchEmployeeId;
    const effectiveEmployeeId = shouldShowOnlyOwnWorkSchedule ? (currentBranchEmployeeId ?? null) : filter.employeeId;
    const effectiveCurrentEmployeeId = shouldShowOnlyOwnWorkSchedule
        ? (currentBranchEmployeeId ?? null)
        : currentFilter.employeeId;

    const calendarAccess = React.useMemo(
        () =>
            buildWorkScheduleCalendarAccess({
                currentBranchEmployeeId: currentBranchEmployeeId ?? null,
                effectiveEmployeeId,
                isSingleEmployeeMode: shouldShowOnlyOwnWorkSchedule,
                canOpenEmployeeLinkAll,
                canOpenEmployeeLinkSelf,
                canCreateVacationAll,
                canCreateVacationSelf,
                canCreateCustomDayAll,
                canCreateCustomDaySelf,
                canEditCustomDayAll,
                canEditCustomDaySelf,
                canCreateScheduleAll,
                canCreateScheduleSelf,
                canEditScheduleAll,
                canEditScheduleSelf,
                canDeleteScheduleAll,
                canDeleteScheduleSelf,
            }),
        [
            canCreateCustomDayAll,
            canCreateCustomDaySelf,
            canCreateScheduleAll,
            canCreateScheduleSelf,
            canCreateVacationAll,
            canCreateVacationSelf,
            canDeleteScheduleAll,
            canDeleteScheduleSelf,
            canEditCustomDayAll,
            canEditCustomDaySelf,
            canEditScheduleAll,
            canEditScheduleSelf,
            canOpenEmployeeLinkAll,
            canOpenEmployeeLinkSelf,
            currentBranchEmployeeId,
            effectiveEmployeeId,
            shouldShowOnlyOwnWorkSchedule,
        ]
    );

    useEffect(() => {
        if (!shouldShowOnlyOwnWorkSchedule || !currentBranchEmployeeId) return;

        setFilter((prevFilter) =>
            prevFilter.employeeId === currentBranchEmployeeId
                ? prevFilter
                : { ...prevFilter, employeeId: currentBranchEmployeeId }
        );
        setCurrentFilter((prevFilter) =>
            prevFilter.employeeId === currentBranchEmployeeId
                ? prevFilter
                : { ...prevFilter, employeeId: currentBranchEmployeeId }
        );
    }, [currentBranchEmployeeId, shouldShowOnlyOwnWorkSchedule]);

    const handleToggleAddEmployeeFromAnotherBranchModal = () =>
        setIsShowAddEmployeeFromAnotherBranchModal((prevState) => !prevState);
    const handleToggleAddAccessRightsModal = () => setShowAddAccessRightsModal((prevState) => !prevState);

    const [createUserBranchRelation] = useCreateUpdateUserBranchRelationMutation({
        context: {
            errorType: "local",
        },
        onError: (error: ApolloError) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });

    const { data: employeesNotInBranchData, refetch: refetchEmployeesNotInBranch } = useGetEmployeesNotInBranchQuery({
        variables: {
            companyId: +currentCompanyId,
            excludeBranchId: +branchId,
        },
        context: { errorType: "local" },
        skip: !currentCompanyId || !branchId || !canShowAddEmployeeFromAnotherBranchAction,
        onCompleted: (data) => {
            const employeesNotInBranch: EmployeeProxy[] =
                data?.user?.company?.employeesNotInBranch?.length && data?.user?.company?.employeesNotInBranch;
            employeesNotInBranch && setEmployeesWithoutAccessCurrentBranch(employeesNotInBranch);
        },
        onError: (error) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });

    const employeesNotInBranch: EmployeeProxy[] = employeesNotInBranchData?.user?.company?.employeesNotInBranch;

    useEffect(() => {
        employeesNotInBranch && setEmployeesWithoutAccessCurrentBranch(employeesNotInBranch);
    }, [employeesNotInBranch]);

    const { data: possitions, loading: loadingPossitions } = useGetEmployeesPositionsQuery({
        variables: { companyId: +currentCompanyId },
        skip: !currentCompanyId,
        onError: (error) => {
            console.error(error);
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });
    const { data: infoCompanyData, loading: loadingInfoCompanyData } = useGetCompanyQuery({
        variables: { companyId: +currentCompanyId },
        skip: !currentCompanyId,
    });
    const { showToast, toastText, setShowToast, toggleShowToast } = useToast();
    const { data: employeesForCheckEmptyList, loading: loadingEmployeesForCheckEmptyList } =
        useGetEmployeeForCheckEmptyListQuery({
            variables: {
                id: effectiveEmployeeId,
                positionId: filter?.positionId,
                companyId: +currentCompanyId,
            },
            skip:
                !currentCompanyId ||
                workScheduleAccessContract.isWorkScheduleAccessPending ||
                workScheduleAccessContract.workSchedulePageAccessMode === "forbidden" ||
                isCurrentBranchEmployeePending,
            context: {
                errorType: "global",
            },
        });
    const filteredEmployees = employeesForCheckEmptyList?.user?.company?.employees?.employees?.filter(
        (employee) => employee.status.id !== 4
    );

    const employeesOptions = (employeesForCheckEmptyList?.user?.company?.employees?.employees || [])
        .map((employee) => ({
            value: employee.id,
            label: `${employee.name} ${employee.surname} (${employee.position.name})`,
            surname: employee.surname,
        }))
        .sort((a, b) => a.surname.localeCompare(b.surname));

    const timeZone = infoCompanyData?.user?.company?.timeZone?.name;

    const { loading: checkScheduleForEmployeeLoading } = useCheckScheduleForEmployeeQuery({
        variables: {
            companyId: Number(currentCompanyId),
            branchId: Number(branchId),
            employeeId: effectiveEmployeeId,
        },
        skip:
            !currentCompanyId ||
            !effectiveEmployeeId ||
            !runJoy ||
            workScheduleAccessContract.isWorkScheduleAccessPending ||
            workScheduleAccessContract.workSchedulePageAccessMode === "forbidden" ||
            isCurrentBranchEmployeePending,
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            const schedules =
                data?.user?.company?.branchesPaginated?.branches?.[0]?.employeesPaginated?.employees?.[0]
                    ?.workSchedules ?? [];
            const now = DateTime.now().setZone(timeZone).startOf("day");
            const hasFutureSchedule = schedules.some((schedule) => {
                return DateTime.fromISO(schedule.endDate).startOf("day") > now;
            });
            setHasExistingSchedule(hasFutureSchedule);
        },
        onError: (error: ApolloError) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });

    // Handle custom event inside modal
    useEffect(() => {
        if (!runJoy) return;
        const handleJoyrideStep = (event: JoyrideStepEvent) => {
            const { direction } = event.detail;
            setEventTrigger((prev) => prev + 1);
            setStepIndex((prevIndex) => {
                if (direction === "back") {
                    return prevIndex - 1;
                } else if (direction === "next") {
                    setKeySchedule((prev) => ++prev);
                    localStorage.setItem("step", "9");
                    return 9;
                } else {
                    return prevIndex;
                }
            });
            setEventTrigger((prev) => prev + 1);
        };
        window.addEventListener("joyrideStepHandler", handleJoyrideStep);
        return () => {
            window.removeEventListener("joyrideStepHandler", handleJoyrideStep);
        };
    }, [runJoy]);

    useEffect(() => {
        const handleJoyrideOpenModal = () => {
            setStepIndex(8);
            setEventTrigger((prev) => prev + 1);
            setScheduleTrigger((prev) => prev + 1);
        };
        window.addEventListener("joyrideOpenModal", handleJoyrideOpenModal);
        return () => {
            window.removeEventListener("joyrideOpenModal", handleJoyrideOpenModal);
        };
    }, [eventTrigger]);
    useEffect(() => {
        const handleMutations = (mutationsList: any) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                    for (const node of mutation.addedNodes) {
                        if (node instanceof HTMLElement && node.classList.contains("work-schedule-modal")) {
                            setEventTrigger((prev) => prev + 1);
                        }
                    }
                    for (const node of mutation.removedNodes) {
                        if (node instanceof HTMLElement && node.classList.contains("work-schedule-modal")) {
                            setEventTrigger((prev) => prev + 1);
                        }
                    }
                }
            }
        };
        const observer = new MutationObserver(handleMutations);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        const initialElement = document.querySelector(".work-schedule-modal");
        if (initialElement) {
            setEventTrigger((prev) => prev + 1);
        }
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const element = document.querySelector(".work-schedule-step");
            if (element) {
                setEventTrigger((prev) => prev + 1);
                clearInterval(intervalId);
            }
        }, 0);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList") {
                    const modalElement = document.getElementById("sheduleModal");
                    if (modalElement) {
                        modalElement.style.overflowY = "scroll";
                    }
                }
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return () => {
            observer.disconnect();
        };
    }, []);

    // editCustomDayModal
    useEffect(() => {
        document.addEventListener("click", handleClickAddVacation);

        window.addEventListener("weekCellClick", handleWeekCellClick);
        window.addEventListener("editCustomDayModal", handleCustomDay);
        return () => {
            document.removeEventListener("click", handleClickAddVacation);
            window.removeEventListener("weekCellClick", handleWeekCellClick);
            window.removeEventListener("editCustomDayModal", handleCustomDay);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const observerRef = useRef<MutationObserver | null>(null);

    useEffect(() => {
        const handleMutation = (mutationsList: MutationRecord[]) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                    const element = document.getElementById("sheduleModalContainer");
                    if (element) {
                        setRun(false);
                        element.classList.add("work-schedule-modal");
                        setTimeout(() => {
                            setRun(true);
                            setStepIndex(8);
                            setEventTrigger((prev) => prev + 1);
                        }, 505);

                        if (observerRef.current) {
                            observerRef.current.disconnect();
                        }
                    }
                }
            }
        };
        observerRef.current = new MutationObserver(handleMutation);
        observerRef.current.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, [scheduleTrigger]);

    const secondComponent = React.useMemo(
        () => (
            <ScheduleCalendarWrapperComponent
                branchId={+branchId}
                filters={{ ...filter, employeeId: effectiveEmployeeId }}
                calendarAccess={calendarAccess}
                timeZone={timeZone}
                showPreloaderHandler={showPreloaderHandler}
                hidePreloaderHandler={hidePreloaderHandler}
                companyId={+currentCompanyId}
                refetchEmployeeList={refetchEmployeeList}
            />
        ),
        [
            branchId,
            timeZone,
            filter,
            effectiveEmployeeId,
            calendarAccess,
            JSON.stringify(filter), // eslint-disable-line react-hooks/exhaustive-deps
            currentCompanyId,
            refetchEmployeeList,
        ]
    );

    const positionsOptions = possitions?.user?.company?.employeePositions?.employeePositions.map((position) => ({
        value: position.id,
        label: position.name,
    }));

    const toggleFilters = () => setShowFilters(!showFilters);
    const showPreloaderHandler = () => {
        setShowPreloader(true);
    };
    const hidePreloaderHandler = () => {
        setShowPreloader(false);
    };
    const handlePositionChange = (selectedOption: Option) => {
        setCurrentFilter((prevFilter) => ({
            ...prevFilter,
            positionId: selectedOption?.value,
        }));
    };

    const handleEmployeesChange = (selectedOption: Option) => {
        setCurrentFilter((prevFilter) => ({
            ...prevFilter,
            employeeId: selectedOption?.value,
        }));
    };

    const applyFilters = () => {
        const newFilter = {
            positionId: currentFilter.positionId,
            employeeId: shouldShowOnlyOwnWorkSchedule ? (currentBranchEmployeeId ?? null) : currentFilter.employeeId,
        };
        if (JSON.stringify(newFilter) !== JSON.stringify(filter)) {
            setFilter(newFilter);
        }
    };

    const clearFilters = () => {
        const defaultFilter: { positionId: number | null; employeeId: number | null } = {
            positionId: null,
            employeeId: shouldShowOnlyOwnWorkSchedule ? (currentBranchEmployeeId ?? null) : null,
        };
        if (JSON.stringify(filter) !== JSON.stringify(defaultFilter)) {
            setFilter(defaultFilter);
        }
        setCurrentFilter(defaultFilter);
    };

    const handleAddAccessRightsNewEmployee = async (values: FormDataAccessRights) => {
        const input: UserBranchRelationInput = {
            branchId: values.branchId,
            employeeId: values.employeeId,
            roleId: values.roleId,
        };
        currentCompanyId &&
            (await createUserBranchRelation({
                variables: {
                    companyId: +currentCompanyId,
                    input: [input],
                    branchId: +branchId,
                },
                onCompleted: async (data) => {
                    await refetchEmployeesNotInBranch();
                    data && handleRefetchEmployeeList();
                },
            }));
        handleToggleAddAccessRightsModal();
    };

    if (
        !branchId ||
        !currentCompanyId ||
        workScheduleAccessContract.isWorkScheduleAccessPending ||
        isCurrentBranchEmployeePending
    ) {
        return <Spinner />;
    }

    if (
        loadingPossitions ||
        loadingInfoCompanyData ||
        loadingEmployeesForCheckEmptyList ||
        checkScheduleForEmployeeLoading
    ) {
        return <Spinner />;
    }

    return (
        <>
            {modalData.show && (
                <AddVacationModal
                    show={modalData.show}
                    handleClose={handleCloseVacation}
                    employeeId={modalData.employeeId}
                    forceRefresh={handleRefetchEmployeeList}
                    toggleShowToast={toggleShowToast}
                    edit={modalData.edit}
                    editDate={editDate}
                />
            )}

            <div>
                <VioletBadge
                    text={t(
                        "On this page, you can set the work schedule of employees for a certain period or day, and create vacations."
                    )}
                />
                <TableHeader
                    title={t("Staff Work Schedule")}
                    paths={[
                        { path: location?.pathname, label: t("Personnel management") },
                        { path: location?.pathname, label: t("Work schedule") },
                    ]}
                    buttons={
                        <Row className="justify-content-end mt-4 mt-lg-0 gx-3">
                            {workScheduleAccessContract.canViewWorkSchedulePageShellActions ? (
                                <>
                                    {canShowAddEmployeeFromAnotherBranchAction && (
                                        <Col xs={2} className="btn-width">
                                            <AddAccessRightsButton
                                                onShow={handleToggleAddEmployeeFromAnotherBranchModal}
                                            />
                                        </Col>
                                    )}
                                    <Col xs lg={5} xxl={3}>
                                        <FiltersButton
                                            filter={filter}
                                            showFilters={showFilters}
                                            onClick={toggleFilters}
                                        />
                                    </Col>
                                </>
                            ) : null}
                        </Row>
                    }
                    showFilters={showFilters}
                    colSize={7}
                    btnColSize={5}
                    calendarView
                >
                    <Row className="gx-3 my-3">
                        <Col lg={8} xl={9}>
                            <Row className="gx-3">
                                <Col
                                    xs={12}
                                    sm={shouldHideEmployeeFilter ? 12 : 6}
                                    className="text-primary mb-3 mb-lg-0"
                                >
                                    <ReactSelect
                                        name={"serviceProviders-selectPosition-field"}
                                        id={"serviceProviders-selectPosition-field"}
                                        options={positionsOptions}
                                        placeholder={t("Select Position")}
                                        onChange={handlePositionChange}
                                        value={
                                            currentFilter.positionId
                                                ? positionsOptions.find(
                                                      (option) => option.value === currentFilter.positionId
                                                  )
                                                : null
                                        }
                                        isSearchable={true}
                                    />
                                </Col>
                                {!shouldHideEmployeeFilter ? (
                                    <Col xs={12} sm={6} className="text-primary mb-3 mb-lg-0">
                                        <ReactSelect
                                            name="employeeId"
                                            id="reviews-employeeId-field"
                                            value={
                                                Number(effectiveCurrentEmployeeId)
                                                    ? employeesOptions.find(
                                                          (option) =>
                                                              option.value === Number(effectiveCurrentEmployeeId)
                                                      )
                                                    : null
                                            }
                                            options={employeesOptions}
                                            placeholder={t("Employee")}
                                            onChange={handleEmployeesChange}
                                            isSearchable={true}
                                        />
                                    </Col>
                                ) : null}
                            </Row>
                        </Col>
                        <Col lg={4} xl={3}>
                            <Row className="gx-3 h-100">
                                <Col xs={6}>
                                    <Button
                                        variant="outline-dark"
                                        className=" w-100 fw-normal h-100"
                                        onClick={clearFilters}
                                    >
                                        {t("clear")}
                                    </Button>
                                </Col>
                                <Col xs={6}>
                                    <Button variant="primary" className="w-100 h-100 px-1" onClick={applyFilters}>
                                        {t("apply")}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </TableHeader>
            </div>
            <div key={keySchedule}>
                {filteredEmployees?.length === 0 ? (
                    <EmptyList title={"No data found for the given values"} />
                ) : (
                    secondComponent
                )}
            </div>
            {customModalData && (
                <CustomDayModal
                    show={customModalData.show}
                    toggleModal={handleCustomModalClose}
                    date={customModalData?.date?.c}
                    resource={customModalData.resource}
                    forceRefresh={() => setKeySchedule((prev) => ++prev)}
                    toggleShowToast={toggleShowToast}
                />
            )}
            {eventTrigger && run && runJoy && (
                <JoyrideWrapper
                    run={run}
                    stepIndex={stepIndex}
                    setStepIndex={setStepIndex}
                    setRun={setRun}
                    setModalJoyride={setModalJoyride}
                    hasExistingSchedule={hasExistingSchedule}
                />
            )}
            {showToast && <ToastComponent show={showToast} setShow={setShowToast} text={toastText} />}

            {canManageBranchEmployees ? (
                <>
                    <AddEmployeeFromAnotherBranchModal
                        isShowAddEmployeeFromAnotherBranchModal={isShowAddEmployeeFromAnotherBranchModal}
                        onCloseAddEmployeeFromAnotherBranch={handleToggleAddEmployeeFromAnotherBranchModal}
                        employeesWithoutAccessCurrentBranch={employeesWithoutAccessCurrentBranch}
                        onSelectedEmployeeToAdd={setSelectedEmployeeToAdd}
                        toggleAddAccessRightsModal={handleToggleAddAccessRightsModal}
                    />
                    <AddAccessRightsModal
                        isAddAccessRightsModal={showAddAccessRightsModal}
                        onCloseAddAccessRightsModal={handleToggleAddAccessRightsModal}
                        selectedEmployeeToAdd={selectedEmployeeToAdd}
                        onAddAccessRightsEmployee={handleAddAccessRightsNewEmployee}
                    />
                </>
            ) : null}

            {isErrorModalOpen ? (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            ) : null}
        </>
    );
};

export default WorkSchedule;
